import { CardSchema, ECardLayoutOptions } from 'constants/graphqlTypes';

export const isVideoCard = (card: CardSchema): boolean => {
  const { mediaTags, cardStyle } = card;
  if (!cardStyle?.layout || cardStyle?.layout === ECardLayoutOptions.Plain) {
    return false;
  }
  return mediaTags?.items[0]?.name === 'video';
};
